import React from 'react';

const Footer = () => {
   return (
      <div>
         <div className='bg-black'>
            <span>Footer</span>


         </div>
         
      </div>
   );
};

export default Footer;